import { css, sliderTokens } from '@salutejs/plasma-new-hope/css';
import {
    bodyL,
    bodyM,
    bodyS,
    bodyXS,
    outlineClear,
    outlineSolidSecondary,
    shadowDownSoftS,
    surfaceAccent,
    surfaceAccentGradient,
    surfaceSolidCard,
    surfaceSolidDefault,
    surfaceSolidTertiary,
    surfaceTransparentCard,
    surfaceTransparentCardActive,
    textAccent,
    textPrimary,
    textSecondary,
} from '@salutejs/sdds-themes/tokens/sdds_insol_next';

export const config = {
    defaults: {
        view: 'default',
        size: 'm',
        pointerSize: 'small',
    },
    variations: {
        view: {
            default: css`
                ${sliderTokens.labelColor}: ${textPrimary};

                ${sliderTokens.rangeValueColor}: ${textSecondary};

                ${sliderTokens.thumbBorderColor}: ${surfaceSolidCard};
                ${sliderTokens.thumbBackgroundColor}: ${surfaceAccent};
                ${sliderTokens.thumbFocusBorderColor}: ${surfaceSolidCard};

                ${sliderTokens.railBackgroundColor}: ${surfaceSolidTertiary};

                ${sliderTokens.fillColor}: ${surfaceSolidDefault};

                ${sliderTokens.tickDotColor}: ${surfaceSolidTertiary};
                ${sliderTokens.tickDotFilledColor}: ${surfaceSolidDefault};

                ${sliderTokens.doubleBoxShadow}: ${shadowDownSoftS};

                ${sliderTokens.textFieldCaretColor}: ${textAccent};
                ${sliderTokens.textFieldColor}: ${textPrimary};
                ${sliderTokens.textFiledFocusColor}: ${textPrimary};
                ${sliderTokens.textFieldPlaceholderColor}: ${textSecondary};

                ${sliderTokens.textFieldBorderColor}: ${outlineClear};
                ${sliderTokens.textFieldBorderColorFocus}: ${outlineSolidSecondary};
                ${sliderTokens.textFieldBorderColorHover}: ${outlineClear};

                ${sliderTokens.textFieldBackgroundColor}: ${surfaceTransparentCard};
                ${sliderTokens.textFieldBackgroundColorHover}: ${surfaceTransparentCard};
                ${sliderTokens.textFieldBackgroundColorFocus}: ${surfaceTransparentCardActive};
            `,
            accent: css`
                ${sliderTokens.labelColor}: ${textPrimary};

                ${sliderTokens.rangeValueColor}: ${textSecondary};

                ${sliderTokens.thumbBorderColor}: ${surfaceSolidCard};
                ${sliderTokens.thumbBackgroundColor}: ${surfaceAccent};
                ${sliderTokens.thumbFocusBorderColor}: ${surfaceSolidCard};

                ${sliderTokens.railBackgroundColor}: ${surfaceSolidTertiary};

                ${sliderTokens.fillColor}: ${surfaceAccent};

                ${sliderTokens.tickDotColor}: ${surfaceSolidTertiary};
                ${sliderTokens.tickDotFilledColor}: ${surfaceAccent};

                ${sliderTokens.doubleBoxShadow}: ${shadowDownSoftS};

                ${sliderTokens.textFieldCaretColor}: ${textAccent};
                ${sliderTokens.textFieldColor}: ${textPrimary};
                ${sliderTokens.textFiledFocusColor}: ${textPrimary};
                ${sliderTokens.textFieldPlaceholderColor}: ${textSecondary};

                ${sliderTokens.textFieldBorderColor}: ${outlineClear};
                ${sliderTokens.textFieldBorderColorFocus}: ${outlineSolidSecondary};
                ${sliderTokens.textFieldBorderColorHover}: ${outlineClear};

                ${sliderTokens.textFieldBackgroundColor}: ${surfaceTransparentCard};
                ${sliderTokens.textFieldBackgroundColorHover}: ${surfaceTransparentCard};
                ${sliderTokens.textFieldBackgroundColorFocus}: ${surfaceTransparentCardActive};
            `,
            gradient: css`
                ${sliderTokens.labelColor}: ${textPrimary};

                ${sliderTokens.rangeValueColor}: ${textSecondary};

                ${sliderTokens.thumbBorderColor}: ${surfaceSolidCard};
                ${sliderTokens.thumbBackgroundColor}: ${surfaceAccent};
                ${sliderTokens.thumbFocusBorderColor}: ${surfaceSolidCard};

                ${sliderTokens.railBackgroundColor}: ${surfaceSolidTertiary};

                ${sliderTokens.fillColor}: ${surfaceAccentGradient};

                ${sliderTokens.tickDotColor}: ${surfaceSolidTertiary};
                ${sliderTokens.tickDotFilledColor}: ${surfaceAccentGradient};

                ${sliderTokens.doubleBoxShadow}: ${shadowDownSoftS};

                ${sliderTokens.textFieldCaretColor}: ${textAccent};
                ${sliderTokens.textFieldColor}: ${textPrimary};
                ${sliderTokens.textFiledFocusColor}: ${textPrimary};
                ${sliderTokens.textFieldPlaceholderColor}: ${textSecondary};

                ${sliderTokens.textFieldBorderColor}: ${outlineClear};
                ${sliderTokens.textFieldBorderColorFocus}: ${outlineSolidSecondary};
                ${sliderTokens.textFieldBorderColorHover}: ${outlineClear};

                ${sliderTokens.textFieldBackgroundColor}: ${surfaceTransparentCard};
                ${sliderTokens.textFieldBackgroundColorHover}: ${surfaceTransparentCard};
                ${sliderTokens.textFieldBackgroundColorFocus}: ${surfaceTransparentCardActive};
            `,
        },
        size: {
            l: css`
                ${sliderTokens.size}: 1.5rem;
                ${sliderTokens.doubleWrapperGap}: 0.375rem;

                ${sliderTokens.labelWrapperGap}: 0.25rem;
                ${sliderTokens.labelWrapperMarginBottom}: 0.25rem;
                ${sliderTokens.labelWrapperMarginRight}: 1rem;
                ${sliderTokens.labelWrapperOnlyIconMarginRight}: 0.625rem;
                ${sliderTokens.labelWrapperVerticalMargin}: 1rem;

                ${sliderTokens.labelFontFamily}: ${bodyL.fontFamily};
                ${sliderTokens.labelFontSize}: ${bodyL.fontSize};
                ${sliderTokens.labelFontStyle}: ${bodyL.fontStyle};
                ${sliderTokens.labelFontWeight}: ${bodyL.fontWeight};
                ${sliderTokens.labelLetterSpacing}: ${bodyL.letterSpacing};
                ${sliderTokens.labelLineHeight}: ${bodyL.lineHeight};

                ${sliderTokens.rangeValueHorizontalMargin}: 0.75rem;
                ${sliderTokens.rangeValueBottomOffset}: 0.875rem;
                ${sliderTokens.rangeValueHorizontalOffset}: 0.875rem;
                ${sliderTokens.rangeValueVerticalMargin}: 0.75rem;

                ${sliderTokens.valueFontFamily}: ${bodyM.fontFamily};
                ${sliderTokens.valueFontSize}: ${bodyM.fontSize};
                ${sliderTokens.valueFontStyle}: ${bodyM.fontStyle};
                ${sliderTokens.valueFontWeight}: ${bodyM.fontWeight};
                ${sliderTokens.valueLetterSpacing}: ${bodyM.letterSpacing};
                ${sliderTokens.valueLineHeight}: ${bodyM.lineHeight};

                ${sliderTokens.tickSize}: 0.5rem;

                ${sliderTokens.currentValueTopOffset}: 1.625rem;

                ${sliderTokens.railThickness}: 0.25rem;
                ${sliderTokens.railBorderRadius}: 0.125rem;

                ${sliderTokens.textFieldWrapperGap}: 0.063rem;
                ${sliderTokens.textFieldBorderWidth}: 0.0625rem;

                ${sliderTokens.textFieldHeight}: 3.5rem;
                ${sliderTokens.textFieldPadding}: 1.25rem 1rem 1.25rem 1rem;
                ${sliderTokens.textFieldBorderRadius}: 0.75rem;
                ${sliderTokens.textFieldFontFamily}: ${bodyL.fontFamily};
                ${sliderTokens.textFieldFontSize}: ${bodyL.fontSize};
                ${sliderTokens.textFieldFontStyle}: ${bodyL.fontStyle};
                ${sliderTokens.textFieldFontWeight}: ${bodyL.fontWeight};
                ${sliderTokens.textFieldLetterSpacing}: ${bodyL.letterSpacing};
                ${sliderTokens.textFieldLineHeight}: ${bodyL.lineHeight};
            `,
            m: css`
                ${sliderTokens.size}: 1.5rem;
                ${sliderTokens.doubleWrapperGap}: 0.375rem;

                ${sliderTokens.labelWrapperGap}: 0.25rem;
                ${sliderTokens.labelWrapperMarginBottom}: 0.25rem;
                ${sliderTokens.labelWrapperMarginRight}: 1rem;
                ${sliderTokens.labelWrapperOnlyIconMarginRight}: 0.625rem;
                ${sliderTokens.labelWrapperVerticalMargin}: 0.75rem;

                ${sliderTokens.labelFontFamily}: ${bodyM.fontFamily};
                ${sliderTokens.labelFontSize}: ${bodyM.fontSize};
                ${sliderTokens.labelFontStyle}: ${bodyM.fontStyle};
                ${sliderTokens.labelFontWeight}: ${bodyM.fontWeight};
                ${sliderTokens.labelLetterSpacing}: ${bodyM.letterSpacing};
                ${sliderTokens.labelLineHeight}: ${bodyM.lineHeight};

                ${sliderTokens.rangeValueHorizontalMargin}: 0.75rem;
                ${sliderTokens.rangeValueBottomOffset}: 0.75rem;
                ${sliderTokens.rangeValueHorizontalOffset}: 0.875rem;
                ${sliderTokens.rangeValueVerticalMargin}: 0.625rem;

                ${sliderTokens.valueFontFamily}: ${bodyS.fontFamily};
                ${sliderTokens.valueFontSize}: ${bodyS.fontSize};
                ${sliderTokens.valueFontStyle}: ${bodyS.fontStyle};
                ${sliderTokens.valueFontWeight}: ${bodyS.fontWeight};
                ${sliderTokens.valueLetterSpacing}: ${bodyS.letterSpacing};
                ${sliderTokens.valueLineHeight}: ${bodyS.lineHeight};

                ${sliderTokens.tickSize}: 0.5rem;

                ${sliderTokens.currentValueTopOffset}: 1.75rem;

                ${sliderTokens.railThickness}: 0.25rem;
                ${sliderTokens.railBorderRadius}: 0.125rem;

                ${sliderTokens.textFieldWrapperGap}: 0.063rem;
                ${sliderTokens.textFieldBorderWidth}: 0.0625rem;

                ${sliderTokens.textFieldHeight}: 3rem;
                ${sliderTokens.textFieldPadding}: 0.875rem 1rem 0.875rem 1rem;
                ${sliderTokens.textFieldBorderRadius}: 0.75rem;
                ${sliderTokens.textFieldFontFamily}: ${bodyM.fontFamily};
                ${sliderTokens.textFieldFontSize}: ${bodyM.fontSize};
                ${sliderTokens.textFieldFontStyle}: ${bodyM.fontStyle};
                ${sliderTokens.textFieldFontWeight}: ${bodyM.fontWeight};
                ${sliderTokens.textFieldLetterSpacing}: ${bodyM.letterSpacing};
                ${sliderTokens.textFieldLineHeight}: ${bodyM.lineHeight};
            `,
            s: css`
                ${sliderTokens.size}: 1rem;
                ${sliderTokens.doubleWrapperGap}: 0.375rem;

                ${sliderTokens.labelWrapperGap}: 0.25rem;
                ${sliderTokens.labelWrapperMarginBottom}: 0.25rem;
                ${sliderTokens.labelWrapperMarginRight}: 1rem;
                ${sliderTokens.labelWrapperOnlyIconMarginRight}: 0.625rem;
                ${sliderTokens.labelWrapperVerticalMargin}: 0.625rem;

                ${sliderTokens.labelFontFamily}: ${bodyS.fontFamily};
                ${sliderTokens.labelFontSize}: ${bodyS.fontSize};
                ${sliderTokens.labelFontStyle}: ${bodyS.fontStyle};
                ${sliderTokens.labelFontWeight}: ${bodyS.fontWeight};
                ${sliderTokens.labelLetterSpacing}: ${bodyS.letterSpacing};
                ${sliderTokens.labelLineHeight}: ${bodyS.lineHeight};

                ${sliderTokens.rangeValueHorizontalMargin}: 0.5rem;
                ${sliderTokens.rangeValueBottomOffset}: 0.625rem;
                ${sliderTokens.rangeValueHorizontalOffset}: 0.625rem;
                ${sliderTokens.rangeValueVerticalMargin}: 0.5rem;

                ${sliderTokens.valueFontFamily}: ${bodyXS.fontFamily};
                ${sliderTokens.valueFontSize}: ${bodyXS.fontSize};
                ${sliderTokens.valueFontStyle}: ${bodyXS.fontStyle};
                ${sliderTokens.valueFontWeight}: ${bodyXS.fontWeight};
                ${sliderTokens.valueLetterSpacing}: ${bodyXS.letterSpacing};
                ${sliderTokens.valueLineHeight}: ${bodyXS.lineHeight};

                ${sliderTokens.tickSize}: 0.5rem;

                ${sliderTokens.currentValueTopOffset}: 1.25rem;

                ${sliderTokens.railThickness}: 0.25rem;
                ${sliderTokens.railBorderRadius}: 0.125rem;

                ${sliderTokens.textFieldWrapperGap}: 0.063rem;
                ${sliderTokens.textFieldBorderWidth}: 0.0625rem;

                ${sliderTokens.textFieldHeight}: 2.5rem;
                ${sliderTokens.textFieldPadding}: 0.5rem 1rem 0.5rem 1rem;
                ${sliderTokens.textFieldBorderRadius}: 0.625rem;
                ${sliderTokens.textFieldFontFamily}: ${bodyS.fontFamily};
                ${sliderTokens.textFieldFontSize}: ${bodyS.fontSize};
                ${sliderTokens.textFieldFontStyle}: ${bodyS.fontStyle};
                ${sliderTokens.textFieldFontWeight}: ${bodyS.fontWeight};
                ${sliderTokens.textFieldLetterSpacing}: ${bodyS.letterSpacing};
                ${sliderTokens.textFieldLineHeight}: ${bodyS.lineHeight};
            `,
        },
        pointerSize: {
            small: css`
                ${sliderTokens.thumbWidth}: 1.5rem;
                ${sliderTokens.thumbHeight}: 1rem;
                ${sliderTokens.thumbBorderWidth}: 0.09375rem 0.1875rem;
                ${sliderTokens.thumbBorderRadius}: 0.6875rem / 0.59375rem;
                ${sliderTokens.thumbInnerContent}: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='3'%3E%3Crect width='12' height='3' rx='1.5' fill='%23FFFFFF'/%3E%3C/svg%3E");

                ${sliderTokens.currentValueTopOffset}: 1.375rem;
            `,
            large: css`
                ${sliderTokens.thumbWidth}: 2rem;
                ${sliderTokens.thumbHeight}: 1.25rem;
                ${sliderTokens.thumbBorderWidth}: 0.125rem 0.25rem;
                ${sliderTokens.thumbBorderRadius}: 0.875rem / 0.75rem;
                ${sliderTokens.thumbInnerContent}: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='4'%3E%3Crect width='16' height='4' rx='2' fill='%23FFFFFF'/%3E%3C/svg%3E");

                ${sliderTokens.currentValueTopOffset}: 1.625rem;
            `,
            none: css`
                ${sliderTokens.thumbWidth}: 0rem;

                ${sliderTokens.currentValueTopOffset}: 1.5rem;
            `,
        },
        disabled: {
            true: css`
                ${sliderTokens.disabledOpacity}: 0.4;
            `,
        },
    },
    intersections: [
        {
            size: 's',
            pointerSize: 'small',
            style: css`
                ${sliderTokens.currentValueTopOffset}: 1rem;
                &.slider-vertical-orientation {
                    ${sliderTokens.currentValueTopOffset}: 1.25rem;
                }
            `,
        },
        {
            size: 'm',
            pointerSize: 'small',
            style: css`
                ${sliderTokens.currentValueTopOffset}: 1.25rem;
                &.slider-vertical-orientation {
                    ${sliderTokens.currentValueTopOffset}: 1.5rem;
                }
            `,
        },
        {
            size: 'l',
            pointerSize: 'small',
            style: css`
                ${sliderTokens.currentValueTopOffset}: 1.25rem;
                &.slider-vertical-orientation {
                    ${sliderTokens.currentValueTopOffset}: 1.5rem;
                }
            `,
        },
        {
            size: 's',
            pointerSize: 'large',
            style: css`
                ${sliderTokens.currentValueTopOffset}: 1.25rem;
                &.slider-vertical-orientation {
                    ${sliderTokens.currentValueTopOffset}: 1.375rem;
                }
            `,
        },
        {
            size: 'm',
            pointerSize: 'large',
            style: css`
                ${sliderTokens.currentValueTopOffset}: 1.5rem;
                &.slider-vertical-orientation {
                    ${sliderTokens.currentValueTopOffset}: 1.625rem;
                }
            `,
        },
        {
            size: 'l',
            pointerSize: 'large',
            style: css`
                ${sliderTokens.currentValueTopOffset}: 1.5rem;
                &.slider-vertical-orientation {
                    ${sliderTokens.currentValueTopOffset}: 1.625rem;
                }
            `,
        },
        {
            size: 's',
            pointerSize: 'none',
            style: css`
                ${sliderTokens.currentValueTopOffset}: 1rem;
                &.slider-vertical-orientation {
                    ${sliderTokens.currentValueTopOffset}: 1rem;
                }
            `,
        },
        {
            size: 'm',
            pointerSize: 'none',
            style: css`
                ${sliderTokens.currentValueTopOffset}: 1.5rem;
                &.slider-vertical-orientation {
                    ${sliderTokens.currentValueTopOffset}: 1.25rem;
                }
            `,
        },
        {
            size: 'l',
            pointerSize: 'none',
            style: css`
                ${sliderTokens.currentValueTopOffset}: 1.5rem;
                &.slider-vertical-orientation {
                    ${sliderTokens.currentValueTopOffset}: 1.25rem;
                }
            `,
        },
    ],
};
